















































import Vue from 'vue'
import Component from 'vue-class-component'
import DataTable from '../components/DataTable.vue'
import CrudForm from '../components/CrudForm.vue'
import { Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import {
  ArchivedPayload,
  Area,
  CrudFormField,
  CrudDialogMode,
  CrudFieldType,
  DataTableAction,
  FetchAreasPayload,
  AreaOrderByInput,
  DetailsField,
  DetailsFieldType
} from '@/utils/types'
import { DataTableHeader } from 'vuetify'
import _ from 'lodash'
import { daysAgoInISO, stringRatio, validationRules } from '@/utils/helpers'

@Component({
  components: { DataTable, CrudForm }
})
export default class Areas extends Vue {
  @Getter areas!: Area[]
  @Getter totalAreas!: number
  @Action fetchAreas!: (payload: FetchAreasPayload) => Promise<void>
  @Action createArea!: (payload: Area) => Promise<boolean>
  @Action updateArea!: (payload: Area) => Promise<boolean>
  @Action archiveArea!: (payload: ArchivedPayload) => Promise<boolean>
  crudDialogMode = CrudDialogMode
  currentTab = 0
  currentCrudDialogMode = CrudDialogMode.NONE
  headers: DataTableHeader[] = [
    { text: 'אזור תעסוקה', value: 'name' },
    { text: 'מעסיקים מאושרים', value: 'approvedBusinessesCount', class: 'red lighten-5' },
    { text: 'מעסיקים רלוונטיים', value: 'relevantBusinessesCount', class: 'red lighten-5' },
    { text: 'מעסיקים שנרשמו ב-30 יום האחרונים', value: 'new30DaysBusinessesCount', class: 'red lighten-5' },
    { text: 'פרסומים פעילים', value: 'jobListingsCount', class: 'red lighten-5' },
    { text: 'משרות פעילות לאיוש', value: 'vacantPositionsCount', class: 'red lighten-5' },
    { text: 'בני נוער רלוונטים', value: 'relevantYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער פעילים', value: 'activeYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער שנרשמו ב-30 יום האחרונים', value: 'new30DaysYouthCount', class: 'blue lighten-5' },
    { text: 'בני נוער פעילים שרושמים שעות', value: 'hourLoggingYouthCount', class: 'blue lighten-5' },
    { text: 'מתחת ל-14', value: 'lessThanFourteenYouthCount', class: 'green lighten-5' },
    { text: '14-15', value: 'fourteenFifteenYouthCount', class: 'green lighten-5' },
    { text: '16', value: 'sixteenYouthCount', class: 'green lighten-5' },
    { text: '17', value: 'seventeenYouthCount', class: 'green lighten-5' },
    { text: '18', value: 'eighteenYouthCount', class: 'green lighten-5' },
    { text: '19-20', value: 'nineteenTwentyYouthCount', class: 'green lighten-5' },
    { text: '21-25', value: 'twentyOneTwentyFiveYouthCount', class: 'green lighten-5' },
    { text: '26 ומעלה', value: 'overTwentySixYouthCount', class: 'green lighten-5' },
    { text: 'יחס', value: 'ratio', class: 'purple lighten-5' },
    { text: 'הערות', value: 'shortNotes', class: 'orange lighten-5' }
  ]

  currentCrudItem: Area = {}
  dialogFields: CrudFormField<Area[keyof Area]>[] = []
  itemsPerPage = 100
  isLoading = false
  orderBy = AreaOrderByInput.ID_DESC
  snackbar = false
  snackbarMessage = ''

  @Watch('currentTab')
  async onCurrentTabChange () {
    await this.fetchFirstPage()
  }

  async mounted () {
    await this.fetchFirstPage()
  }

  async fetchFirstPage () {
    return this.fetchPage(1)
  }

  closeDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.dialogFields.length = 0
  }

  openDialog (mode: CrudDialogMode, item: Area = {}) {
    this.currentCrudItem = item
    this.dialogFields.length = 0
    if (mode !== CrudDialogMode.DELETE) {
      this.dialogFields.push({
        name: 'name',
        value: item.name || '',
        rules: [validationRules.requiredValue],
        label: 'שם אזור תעסוקה',
        type: CrudFieldType.TEXT,
        isLarge: true
      })
      this.dialogFields.push({
        name: 'location',
        value: item.location ?? { lat: 32.0749, lng: 34.7817 },
        label: 'נ"צ',
        type: CrudFieldType.LOCATION,
        isLarge: true
      })
      this.dialogFields.push({
        name: 'emailNotificationRadius',
        value: item.emailNotificationRadius || 0,
        rules: [validationRules.requiredValue],
        label: 'רדיוס התראה במייל',
        type: CrudFieldType.NUMBER,
        isLarge: false,
        min: 0
      })
    }
    this.currentCrudDialogMode = mode
  }

  async handleSubmit (eventData: CrudFormField[]) {
    let success = false
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        success = await this.executeCreate(eventData)
        break
      case CrudDialogMode.EDIT:
        success = await this.executeUpdate(eventData)
        break
      case CrudDialogMode.DELETE:
        success = await this.executeArchive(this.currentCrudItem.id)
        break
    }
    if (success) {
      this.snackbarMessage = 'הפעולה בוצעה בהצלחה'
      this.closeDialog()
    } else {
      this.snackbarMessage = 'הפעולה נכשלה. אנא ודאו את הטופס'
    }
    this.snackbar = true
  }

  async executeCreate (eventData: CrudFormField[]) {
    const radiusStringValue = eventData.find(f => f.name === 'emailNotificationRadius')?.value
    const emailNotificationRadiusAsNum = parseInt(radiusStringValue || '0', 10) || 0
    const areaData = _.zipObjectDeep(eventData.map(field => field.name), eventData.map(field => field.value)) as Area
    areaData.emailNotificationRadius = emailNotificationRadiusAsNum
    return this.createArea(areaData)
  }

  async executeUpdate (eventData: CrudFormField[]) {
    const radiusStringValue = eventData.find(f => f.name === 'emailNotificationRadius')?.value
    const emailNotificationRadiusAsNum = parseInt(radiusStringValue || '0') || 0
    return this.updateArea({ id: this.currentCrudItem.id, ..._.zipObjectDeep(eventData.map(f => f.name), eventData.map(f => f.value)), emailNotificationRadius: emailNotificationRadiusAsNum })
  }

  async executeArchive (id?: string) {
    if (!id) return false
    return this.archiveArea({ id, isArchived: !this.isArchived })
  }

  async fetchPage (page: number): Promise<void> {
    this.isLoading = true
    await this.fetchAreas({
      limit: this.itemsPerPage,
      page,
      isArchived: this.isArchived,
      orderBy: this.orderBy
    })
    this.isLoading = false
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת אזור תעסוקה'
      case CrudDialogMode.EDIT:
        return 'עריכת אזור תעסוקה'
      case CrudDialogMode.DELETE:
        return this.isArchived ? 'להוציא מהארכיון?' : 'להעביר לארכיון?'
    }
  }

  get detailFields (): DetailsField[] {
    const columnA: DetailsField[] = [
      {
        href: (item: Area) => item.activeYouthCount ? `/users?roles=AUTHENTICATED&areaIds=${item.id}&lastActivityGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער פעילים',
        type: DetailsFieldType.LINK,
        value: 'activeYouthCount'
      },
      {
        href: (item: Area) => item.hourLoggingYouthCount ? `/users?roles=AUTHENTICATED&areaIds=${item.id}&lastShiftLogGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער פעילים שרושמים שעות',
        type: DetailsFieldType.LINK,
        value: 'hourLoggingYouthCount'
      },
      {
        href: (item: Area) => item.relevantYouthCount ? `/users?roles=AUTHENTICATED&areaIds=${item.id}&lastActivityGte=${daysAgoInISO(180)}` : '',
        text: 'בני נוער רלוונטיים',
        type: DetailsFieldType.LINK,
        value: 'relevantYouthCount'
      },
      {
        href: (item: Area) => item.new30DaysYouthCount ? `/users?roles=AUTHENTICATED&areaIds=${item.id}&createdAtGte=${daysAgoInISO(30)}` : '',
        text: 'בני נוער שנרשמו ב-30 יום האחרונים',
        type: DetailsFieldType.LINK,
        value: 'new30DaysYouthCount'
      },
      {
        text: 'יחס',
        type: DetailsFieldType.TEXT,
        value: 'ratio'
      }
    ]
    const columnB: DetailsField[] = [
      {
        href: (item: Area) => item.approvedBusinessesCount ? `/employers?areaIds=${item.id}&isApproved=true` : '',
        text: 'מעסיקים מאושרים',
        type: DetailsFieldType.LINK,
        value: 'approvedBusinessesCount'
      },
      {
        href: (item: Area) => item.relevantBusinessesCount ? `/employers?areaIds=${item.id}&lastActivityGte=${daysAgoInISO(365)}&isApproved=true` : '',
        text: 'מעסיקים רלוונטיים',
        type: DetailsFieldType.LINK,
        value: 'relevantBusinessesCount'
      },
      {
        href: (item: Area) => item.new30DaysBusinessesCount ? `/employers?areaIds=${item.id}&createdAtGte=${daysAgoInISO(30)}&isApproved=true` : '',
        text: 'מעסיקים שנרשמו ב-30 יום האחרונים',
        type: DetailsFieldType.LINK,
        value: 'new30DaysBusinessesCount'
      },

      {
        href: (item: Area) => item.jobListingsCount ? `/job-listings?areaIds=${item.id}` : '',
        text: 'פרסומים פעילים',
        type: DetailsFieldType.LINK,
        value: 'jobListingsCount'
      },
      {
        href: (item: Area) => item.vacantPositionsCount ? `/job-listings?areaIds=${item.id}` : '',
        text: 'משרות פעילות לאיוש',
        type: DetailsFieldType.LINK,
        value: 'vacantPositionsCount'
      }
    ]
    const afterColumns = [
      {
        text: 'רדיוס התראה במייל',
        type: DetailsFieldType.TEXT,
        value: 'emailNotificationRadius'
      },
      {
        action: async (item: Area) => this.updateArea({ id: item.id, notes: item.notes }),
        text: 'הערות',
        isLarge: true,
        type: DetailsFieldType.TEXT_AREA,
        value: 'notes'
      }
    ]
    return _.zipWith(columnA, columnB, (a, b) => [a, b]).flat().concat(afterColumns)
  }

  get formattedAreas (): Area[] {
    return this.areas.map(area => ({
      ...area,
      shortNotes: _.words(area.notes).length > 5 ? `${_.words(area.notes).slice(0, 5).join(' ')}...` : area.notes,
      ratio: stringRatio(area.availableYouthCount, area.vacantPositionsCount)
    }))
  }

  get dialog () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  get isArchived () {
    return this.currentTab === 1
  }

  get tableActions (): DataTableAction<Area>[] {
    return [
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: this.openDialog.bind(this, CrudDialogMode.EDIT)
      },
      {
        text: this.isArchived ? 'הפעלה' : 'הקפאה',
        icon: this.isArchived ? 'mdi-backup-restore' : 'mdi-archive',
        handler: this.openDialog.bind(this, CrudDialogMode.DELETE)
      }
    ]
  }
}
